import Form from "./Form";

export default function JoinUs() {
  return (
    <section
      id="founders-circle"
      className="bg-gray-100 py-12 px-6 text-center"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-[#004E98]">
          Join the Founders’ Circle Today!
        </h2>
        <p className="text-lg text-gray-700 mt-2">
          Let’s work together to make a lasting difference and elevate your
          brand.
        </p>
        <div className="mt-6 space-y-6 text-left">
          <div className="">
            <h3 className="text-xl font-semibold text-gray-900">
              Boost Your Brand, Make an Impact
            </h3>
            <p className="text-gray-700 mt-2 font-light">
              Partnering with the Founders’ Circle isn’t just about giving—it’s
              about elevating your brand. Align with a meaningful cause, enhance
              your reputation, and connect with a community that values
              purpose-driven leadership.
            </p>
          </div>
          <div className="">
            <h3 className="text-xl font-semibold text-gray-900">
              Maximize Visibility & Influence
            </h3>
            <p className="text-gray-700 mt-2 font-light">
              Each tier offers unique opportunities for brand exposure,
              networking, and exclusive benefits designed to create real
              business value.
            </p>
            {/* Learn More Link */}
            <div className="text-right">
              <a
                href="#foundersTier"
                className="inline-flex items-center text-[#039B86] font-base text-lg hover:underline"
              >
                Discover the benefits of each tier in the Founders’ Circle
                <svg
                  className="w-5 h-5 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div className="">
            <h2 className="text-2xl font-semibold text-[#FF6700]">
              Let’s Talk!
            </h2>
            <p className="text-gray-700 mt-2">
              Fill out the form below, and we’ll help you find the perfect way
              to make an impact while strengthening your brand.
            </p>
          </div>
        </div>
      </div>

      {/* New Section: Let's Talk! */}
      <div className="py-12 px-6">
        <div className="max-w-sm mx-auto text-center">
          <Form />
        </div>
      </div>
    </section>
  );
}
